export default class Helper {
  static formatDate(dateString) {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }

  static capitalize(str) {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  }

  // Add more shared methods here
  
}